/** Kurze Töne für die Packstation (WebAudio, ohne Dateien). Fehlscan tief und lang, Treffer kurz und hoch. */
let ctx: AudioContext | null = null;
export function ton(art: 'ok' | 'fehler' | 'fertig') {
  try {
    ctx ??= new AudioContext();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = art === 'fehler' ? 'square' : 'sine';
    o.frequency.value = art === 'fehler' ? 196 : art === 'fertig' ? 1046 : 880;
    g.gain.value = art === 'fehler' ? 0.15 : 0.08;
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + (art === 'fehler' ? 0.35 : 0.07));
  } catch { /* kein Audio verfügbar */ }
}
